import React, { createContext, useState, useContext, useCallback } from "react";
import {apiInstance} from "../api/api";
// import { useAuthenticatedEffect } from "../components/useauthenticatedeffect";

const AccountingReportsContext = createContext();

export const useAccountingReports = () => useContext(AccountingReportsContext);

export const AccountingReportsProvider = ({ children }) => {
    const [balanceSheetData, setBalanceSheetData] = useState(null);
    const [incomeStatementData, setIncomeStatementData] = useState(null);
    const [trialBalanceData, setTrialBalanceData] = useState(null);
    const [incomeStatementLoading, setIncomeStatementLoading] = useState(false);
    const [incomeStatementError, setIncomeStatementError] = useState(null);

    const fetchBalanceSheet = useCallback(async (startDate, endDate, financialYearId, storeId) => {
        try {
            const response = await apiInstance.get("/reports/balance-sheet/", {
                params: { start_date: startDate, end_date: endDate, financial_year_id: financialYearId, store_id: storeId }
            });
            setBalanceSheetData(response.data);
        } catch (error) {
            console.error("Error loading balance sheet data", error);
        }
    }, []);

    const fetchIncomeStatement = useCallback(async (startDate, endDate, financialYearId, storeId) => {
        setIncomeStatementLoading(true);
        setIncomeStatementError(null);
        setIncomeStatementData(null);
        try {
            const response = await apiInstance.get("/reports/income-statement/", {
                params: { start_date: startDate, end_date: endDate, financial_year_id: financialYearId, store_id: storeId }
            });
            setIncomeStatementData(response.data);
        } catch (error) {
            console.error("Error loading income statement data", error);
            setIncomeStatementError(
                error?.response?.data?.detail || "Unable to load the income statement."
            );
        } finally {
            setIncomeStatementLoading(false);
        }
    }, []);

    const fetchTrialBalance = useCallback(async (startDate, endDate, financialYearId, storeId) => {
        try {
            const response = await apiInstance.get("/reports/trial-balance/", {
                params: { start_date: startDate, end_date: endDate, financial_year_id: financialYearId, store_id: storeId }
            });
            setTrialBalanceData(response.data);
        } catch (error) {
            console.error("Error loading trial balance data", error);
        }
    }, []);

    return (
        <AccountingReportsContext.Provider value={{
            balanceSheetData,
            incomeStatementData,
            trialBalanceData,
            incomeStatementLoading,
            incomeStatementError,
            fetchBalanceSheet,
            fetchIncomeStatement,
            fetchTrialBalance
        }}>
            {children}
        </AccountingReportsContext.Provider>
    );
}